import { render, staticRenderFns } from "./setProductDialog.vue?vue&type=template&id=63b9b53e&scoped=true"
import script from "./setProductDialog.vue?vue&type=script&lang=js"
export * from "./setProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9b53e",
  null
  
)

export default component.exports